import React from 'react';
import Icon from '../../../components/AppIcon';

const SkillsStats = ({ stats }) => {
  const getStatIcon = (label) => {
    const iconMap = {
      'Total Technologies': 'Code',
      'Years Experience': 'Calendar',
      'Certifications': 'Award',
      'Projects Completed': 'CheckCircle'
    };
    return iconMap[label] || 'TrendingUp';
  };

  const getStatColor = (label) => {
    const colorMap = {
      'Total Technologies': 'text-blue-600 bg-blue-100',
      'Years Experience': 'text-green-600 bg-green-100',
      'Certifications': 'text-purple-600 bg-purple-100',
      'Projects Completed': 'text-orange-600 bg-orange-100'
    };
    return colorMap[label] || 'text-primary bg-primary/10';
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
      {stats.map((stat, index) => (
        <div
          key={stat.label}
          className="bg-card rounded-lg border border-border p-6 text-center hover:shadow-md transition-shadow duration-300"
        >
          <div className={`inline-flex items-center justify-center w-12 h-12 rounded-lg mb-4 ${getStatColor(stat.label)}`}>
            <Icon name={getStatIcon(stat.label)} size={24} />
          </div>
          <div className="text-2xl font-bold text-text-primary mb-1">
            {stat.value}
          </div>
          <div className="text-sm text-text-secondary">
            {stat.label}
          </div>
          {stat.growth && (
            <div className="flex items-center justify-center mt-2 text-xs text-success">
              <Icon name="TrendingUp" size={12} className="mr-1" />
              +{stat.growth}% this year
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SkillsStats;